import Vue from "vue";


Vue.filter('getText', (object, field = 'name', defaultText = '') => {
  return object && (typeof object[field] !== "undefined") ? object[field] : defaultText
})
